import { Controller } from "stimulus"

export default class extends Controller {
  static values = { points: Object }

  connect() {
    const data = this.pointsValue
    if (!data || !data.community || !data.nearest_office) { return }

    const community = [data.community.latitude, data.community.longitude]
    const office = [data.nearest_office.latitude, data.nearest_office.longitude]

    this.map = window.L.map(this.element)

    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map)

    // Every other Kustom office, muted, added first so it sits underneath.
    ;(data.other_offices || []).forEach(other => {
      window.L.circleMarker([other.latitude, other.longitude], {
        radius: 5,
        color: "#999999",
        fillColor: "#cccccc",
        fillOpacity: 0.4,
        weight: 1
      }).addTo(this.map).bindTooltip(`${other.name} (${other.division_code})`)
    })

    window.L.marker(office, { icon: this.icon("dispatch-office-icon", data.nearest_office.name) })
      .addTo(this.map)
      .bindPopup(this.officePopup(data.nearest_office))

    window.L.marker(community, { icon: this.icon("dispatch-community-icon", data.community.name) })
      .addTo(this.map)
      .bindPopup(this.communityPopup(data.community))

    this.map.fitBounds(window.L.latLngBounds([community, office]).pad(0.3))

    // Leaflet can measure a stale container inside a Bootstrap panel.
    setTimeout(() => this.map.invalidateSize(), 0)
  }

  disconnect() {
    if (this.map) { this.map.remove() }
  }

  icon(className, label) {
    return window.L.divIcon({
      html: `<div class="${className}"><i class="fa fa-map-marker"></i><div class="dispatch-marker-label">${label}</div></div>`,
      className: ""
    })
  }

  officePopup(office) {
    return `
      <div class="dispatch-popup">
        <div><strong>${office.name}</strong> (${office.division_code})${office.acer ? ' (ACER)' : ''}</div>
        <div>${office.address || ""}</div>
        ${office.phone ? `<div>Office: <a href="tel:${office.phone}">${office.phone}</a></div>` : ""}
        ${office.gm_name ? `<div>GM: ${office.gm_name}</div>` : ""}
        <div>${office.air_miles} air miles (${office.coverage})</div>
      </div>
    `
  }

  communityPopup(community) {
    return `
      <div class="dispatch-popup">
        <div><strong>${community.name}</strong></div>
        <div>${community.address || ""}</div>
      </div>
    `
  }
}
